@use "ui/styles/colorsOld";
@use "ui/styles/studio";

.wrapper {
  padding: 1em;
  border: 1px solid studio.$studioBorderColor;
  background-color: studio.$studioShellBackgroundColor;
  text-align: center;
  border-radius: studio.$studioBorderRadius;
  margin: 0.75em;
  color: studio.$studioColor;
  font-weight: 500;
  text-wrap: wrap;

  &.compact {
    padding: 0.5em 0.75em;
  }
}

.noSearchResultsWrapper {
  @extend .wrapper;

  .searchTerm {
    q {
      font-weight: 400;
      color: studio.$studioColorLight;
    }
  }

  .filters {
    font-weight: 400;
    color: studio.$studioColorLight;
  }
}
